import React from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Waypoint } from 'react-waypoint';


export default function CustomInfiniteScrollDiv(props) {
    const { component, loadMoreTask,
        customClasses, loadMoreContent } = props;
    const classes = customStyles();

    // const onSelectAllClick = (e) => {
    //     if (e.target.checked) {
    //         const newSelecteds = details && details.map((n) => n.id);
    //         onSelected(newSelecteds);
    //         return;
    //     }
    //     onSelected([]);
    // };

    return (
        <div className={clsx(customClasses, classes.tablecontain)} style={{ height: "100%", overflow: "auto" }}>
            {component}
            {
                loadMoreContent && <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                    setTimeout(function () {
                        loadMoreTask(previousPosition);
                    }, 500);
                }}>
                    <div>
                        <div className={classes.loadMoreCircle}></div>
                    </div>
                </Waypoint>
            }

            {/* {
                    overflow &&
                    <>
                        <div className={clsx(classes.tableScrollIcon, classes.tableScrollIconLeft)}>
                            <Image
                                onClick={() => onScroll(-40)}
                                src={ScrollRight}
                                preview={false}
                            />
                        </div><div className={clsx(classes.tableScrollIcon, classes.tableScrollIconRight)}>
                            <Image
                                src={ScrollRight}
                                onClick={() => onScroll(40)}
                                preview={false}
                            />
                        </div>

                    </>
                } */}
        </div>
    );
}
